import { render, staticRenderFns } from "./resourcemanege.vue?vue&type=template&id=5a40968d&scoped=true"
import script from "./resourcemanege.vue?vue&type=script&lang=js"
export * from "./resourcemanege.vue?vue&type=script&lang=js"
import style0 from "./resourcemanege.vue?vue&type=style&index=0&id=5a40968d&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a40968d",
  null
  
)

export default component.exports